import { Divider, Paper } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ILocation } from 'wisestep-base';

import AdvancedFiltersHeader from '../../../utils/AdvancedFiltersHeader';
import RelevanceSlider from '../../WsCustomSlider/RelevanceSlider';
import { AiContactAvailabilityFilter } from '../components';
import { aiContactPreferrence } from '../components/AiContactAvailabilityFilter';
import AiLocationFilter from '../components/AiLocationsFilter';
import JobsCrmSmartSourceAdvanceFiltersFormProps from '../models/JobsCrmSmartSourceAdvanceFiltersFormProps';
import JobsCrmSmartSourceAdvanceFiltersProps from '../models/JobsCrmSmartSourceAdvanceFiltersProps';

const WsJobsCrmSmartSourceAdvanceFilter = ({
  onApplyFilters,
  job,
  defaultValues,
}: JobsCrmSmartSourceAdvanceFiltersProps) => {
  const methods = useForm<JobsCrmSmartSourceAdvanceFiltersFormProps>({ defaultValues });
  const { handleSubmit, reset } = methods;
  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const resetDefault = () => {
    onApplyFilters({
      aiLocations: 'Same State as Job',
      contactAvailability: Object.values(aiContactPreferrence),
      relevance: [90, 100],
      customLocations: [] as ILocation[],
    });
  };

  const onFormSubmit = (data: JobsCrmSmartSourceAdvanceFiltersFormProps) => {
    onApplyFilters(data);
  };

  return (
    <FormProvider {...methods}>
      <Paper sx={{ mt: 2 }}>
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(onFormSubmit)}
          onReset={resetDefault}
        >
          <AdvancedFiltersHeader />
          <Divider />
          <List>
            <RelevanceSlider
              title="Relevance"
              name="relevance"
              marks={[
                { value: 30, label: '30%' },
                { value: 40, label: '40%' },
                { value: 50, label: '50%' },
                { value: 60, label: '60%' },
                { value: 70, label: '70%' },
                { value: 80, label: '80%' },
                { value: 90, label: '90%' },
                { value: 100, label: '100%' },
              ]}
            />
            <AiLocationFilter name="aiLocations" job={job} />
            <AiContactAvailabilityFilter name="contactAvailability" />
          </List>
        </Box>
      </Paper>
    </FormProvider>
  );
};
export default WsJobsCrmSmartSourceAdvanceFilter;
